//login call
const getCryporCurrencyList = (data) => {
    console.log(data);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", data.Token);
    
    var raw = JSON.stringify({
        "user_id": data.user_id,
        "slug": data.slug,
        "start_index": data.start_index,
        "limit": data.limit,
    }); 
    console.log(data);
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/cryptocurrencylist`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error));
};

const getTotalunit = (data) => {
    console.log(data);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", data.Token);
    
    var raw = JSON.stringify({
        "user_id": data.user_id,
        "slug": data.slug,
        "portfolio_type_id": data.portfolio_type_id,
    }); 
    console.log(data);
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/gettotalunit`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error));
};
const getFetchdropdown = (data) => {
    const urlencoded = new URLSearchParams();
    urlencoded.append("user_id", data.user_id);
    urlencoded.append("requested_agent", navigator.userAgent + ":" + data.user_id); // simulate get_requested_user_agent() result

    const requestOptions = {
        method: 'POST',
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: urlencoded
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/getallportfolio`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error));
};

module.exports = {
    getCryporCurrencyList,
    getTotalunit,
    getFetchdropdown
};
